<template>
    <div style="width:100%;height:100%;background:rgba(240, 242, 243, 1);display:flex;flex-direction: column;">
        <div style="height:50px;background:#fff;box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);">
            <span style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight: bold;line-height: 50px;padding-left:32px;;">即时通话质检</span>
            <div style="float: right;">
                <span @click="queryRecord" style="display:inline-block;width:100px;height:32px;line-height: 32px;background: rgba(58, 220, 255, 1);font-size:14px;color:#fff;text-align: center;cursor:pointer;float: left;margin-top:9px;">查看阻断记录</span>
                <span style="color:rgba(179, 184, 193, 1);font-size:13px;float: left;margin:16px 11px 0 36px;">自动阻断</span>
                <a-switch style="float: left;margin:14px 37px 0 0;" @change="changeState" v-model="blockStatus" />
                <img @click="showVoice(false)" v-if="ifVoice" src="../../assets/img/voice.svg" style="width:22px;margin:14px 46px 0 0;cursor: pointer;" alt="">
                <img @click="showVoice(true)" v-if="!ifVoice" src="../../assets/img/no-voice.svg" style="width:22px;margin:14px 46px 0 0;cursor: pointer;" alt="">
            </div>
        </div>
        <div style="flex:1;padding:20px 24px 30px;display: flex;overflow-y: auto;">
            <div style="flex:1;height:100%;background:#fff;box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);padding:16px 20px;display: flex;flex-direction: column;">
                <div style="color:rgba(0, 0, 0, 1);font-size:13px;height: 30px;;">号码列表</div>
                <div style="flex: 1;">
                    <div v-if="numberData.length==0" style="text-align: center;margin-top:200px;">
                        <div>
                            <img style="width:80px;" src="../../assets/img/no-data.png" alt="">
                        </div>
                        <div style="color:rgba(179, 184, 193, 1);font-size:14px;">无数据</div>
                    </div>
                    <div v-if="numberData.length!=0">
                        <a-table rowKey="caller" :data-source="numberData" :pagination='false' :loading="ifShowLoading" >
                            <a-table-column key="caller" title="主叫号码" data-index="caller" />
                            <a-table-column key="callee" title="被叫号码" data-index="callee" />
                            <a-table-column key="callTime" title="时间" data-index="callTime" />
                            <a-table-column key="duration" title="秒数" data-index="duration" />
                            <a-table-column key="warningStatus" title="状态" data-index="warningStatus">
                                <template slot-scope="text, record">
                                    <div v-if="record.warningStatus==2">
                                        <span style="color:rgba(246, 76, 79, 1);font-size:14px;float: left;margin-top:2px;">预警</span>
                                        <img style="width:20px;color:rgba(246, 76, 79, 1);float: left;margin-left:6px;" src="../../assets/img/warning.svg" alt="">
                                    </div>
                                </template>
                            </a-table-column>
                            <a-table-column key="status" title="操作" data-index="status">
                                <template slot-scope="text, record">
                                    <div>
                                        <span :class="{'del-active':record.id==selectedId}" class="num-del" @click="viewDel(record.id, record.callee, record.duration, 1, record.callTime)">
                                            详情
                                        </span>
                                    </div>
                                </template>
                            </a-table-column>
                        </a-table>
                    </div>
                </div>
            </div>
            <div style="width:610px;height:100%;background:#fff;margin-left:20px;box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);padding:0 20px 16px;display: flex;flex-direction: column;">
                <div style="border-bottom: 1px solid rgba(229, 229, 229, 1);padding:11px 0 15px 0;display: flex;height:50px;">
                    <span style="color:rgba(0, 0, 0, 1);font-size:13px;display: inline-block;width:160px;margin-top:4px;">监听对话</span>
                    <div style="float: right;flex:1">
                        <span style="color:rgba(179, 184, 193, 1);font-size:13px;float: left;margin-top:4px;">设置关键词：</span>
                        <a-input v-model="keyWord" style="margin-left:8px;height:28px;float: left;display: inline-block;width:320px;" placeholder="关键词1,关键词2,小写逗号分隔,..." />
                    </div>
                </div>
                <div style="flex:1;overflow-y: auto;">
                    <div v-if="chatList.length==0" style="text-align: center;margin-top:200px;">
                        <div>
                            <img style="width:80px;" src="../../assets/img/no-data.png" alt="">
                        </div>
                        <div style="color:rgba(179, 184, 193, 1);font-size:14px;">无数据</div>
                    </div>
                    <div v-if="chatList.length!=0" style="padding-top:15px;overflow-y: auto;height:100%;">
                        <div v-for="(item,index) in chatList" :key="index">
                            <div class="user-left" v-if="item.speaker==0">
                                <img src="../../assets/img/user1.png" alt="">
                                <div>{{item.content}}</div>
                            </div>
                            <div class="user-right" v-if="item.speaker==1">
                                <div v-html="highlightText(item.content)"></div>
                                <img src="../../assets/img/user2.png" alt="">
                            </div>
                            <div style="clear: both;"></div>
                        </div>
                    </div>
                </div>
                <div style="height: 64px;border-top:1px solid rgba(229, 229, 229, 1);padding:17px 0 0 0;color:rgba(153, 155, 157, 1);font-size:13px;position: relative">
                    <div>
                        <span>被叫号码：</span>
                        <span v-if="chatList.length!=0" style="color:rgba(0, 0, 0, 1);font-size: 15px;font-weight: bold;;">{{ callee }}</span>
                    </div>
                    <div style="margin-top:7px;">
                        <span>秒数计时：</span>
                        <span v-if="chatList.length!=0" style="color:rgba(246, 76, 79, 1);font-size:15px;font-weight: bold;">{{ duration }}</span>
                        <span v-if="chatList.length!=0" style="color:rgba(246, 76, 79, 1);font-size: 13px;">s</span>
                    </div>
                    <span v-if="chatList.length!=0" @click="blockNumber" style="display: inline-block;width:64px;height:32px;text-align: center;line-height: 32px;cursor: pointer;background:rgba(246, 76, 79, 1);color:#fff;font-size: 13px;position: absolute;right:20px;top:24px;;">阻断</span>
                </div>
            </div>
        </div>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="recoedModal" title="最近30天阻断记录列表" footer='' width='968px'>
            <div class="output-word-modal modal-public">
                <a-divider style="margin:0px;" type="horizontal" />
                <div style="padding:21px 24px 20px;">
                    <a-table rowKey="caller" :data-source="blockList" :pagination='false' :loading="ifShowLoading" :scroll="{ y: 400 }">
                        <a-table-column key="caller" title="主叫号码" data-index="caller" />
                        <a-table-column key="callee" title="被叫号码" data-index="callee" />
                        <a-table-column key="callTime" title="时间" data-index="callTime" />
                        <a-table-column key="duration" title="时长" data-index="duration" />
                        <a-table-column key="blockType" title="阻断类型" data-index="blockType" />
                    </a-table>
                </div>
            </div>
        </a-modal>
        <audio id="myAudio" style="display:none" controls autoplay loop :src="voiceUrl2"></audio>
    </div>
</template>

<script>
    export default {
        name: 'Chat',
        data() {
            return {
                ifVoice: false,
                numberData: [],
                recoedModal: false,
                chatList: [],
                ifShowLoading: false,
                blockStatus: false,
                duration: '',
                callee: '',
                blockList: [],
                id: '',
                keyWord: '',
                timer: null,
                chatObj: {},
                selectedId: '',
                // voiceUrl: 'https://tts.china-ll.com/tts?text=这是我的声音，可以帮您完成语音通知！&format=wav&speaker=47&voice=&speechRate=0&timestamp='
                // voiceUrl: '../../assets/mp3/di.MP3',
                voiceUrl2: 'https://mikecc-intelligence.oss-cn-beijing.aliyuncs.com/file/di.MP3',
                ifWarn: false,
                audio: '',
                timer2: null,
                callTime: ''
            }   
        },
        methods: {
            changeState(checked) {
                this.axios.post('/api/callQualityInspection/updateBlockStatus', {
                    blockStatus: checked?1:2,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryState()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            showVoice(flag) {
                this.ifVoice = flag
                if(!flag){
                    this.audio.pause(); 
                }
            },
            queryRecord() {
                this.recoedModal = true
                this.queryBlockList()
            },
            queryCall() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/callQualityInspection/list', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.chatObj = {}
                        this.numberData = response.data.data
                        const currentTime = new Date().getTime(); // 当前时间转换为时间戳
                        let count = 0
                        for(let i = 0; i < this.numberData.length; i++){
                            let knownTime = new Date(this.numberData[i]['callTime']).getTime();
                            let timeDiff = currentTime - knownTime;
                            let secondsDiff = Math.floor(timeDiff / 1000);
                            this.numberData[i]['duration'] = secondsDiff
                            this.chatObj[this.numberData[i]['id']] = false
                            if(this.numberData[i]['warningStatus']==2){
                                count++
                            }
                        }
                        if(count == 0){
                            this.ifWarn = false
                        }else{
                            this.ifWarn = true
                        }
                        if(this.ifVoice&&this.ifWarn){
                            this.audio.play();
                        }else{
                            this.audio.pause();
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            viewDel(id, callee, duration, type, callTime) {
                this.callTime = callTime
                this.selectedId = id
                const currentTime = new Date().getTime(); // 当前时间转换为时间戳
                Object.keys(this.chatObj).forEach(key => {
                    if(key == id){
                        this.chatObj[id] = true
                    }else{
                        this.chatObj[key] = false
                    }
                });
                this.id = id
                this.callee = callee
                if(type == 1){
                    this.duration = duration
                }else{
                    let knownTime = new Date(this.callTime).getTime();
                    let timeDiff = currentTime - knownTime;
                    this.duration = Math.floor(timeDiff / 1000);
                }
                
                this.axios(
                    {
                        method:'get',
                        url:'/api/callQualityInspection/detail', 
                        params: {
                            id: id
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.chatList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            highlightText(text) {
                let arr = this.keyWord.split(",")
                arr.forEach(name => {
                    if (text.includes(name)) {
                        text = text.replace(new RegExp(name, 'g'), `<span style="color: red">${name}</span>`);
                    }
                });
                return text;
            },
            queryState() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/callQualityInspection/autoBlockStatus', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.blockStatus = response.data.data.blockStatus==1?true:false
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryBlockList() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/callQualityInspection/blockList', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.blockList = response.data.data 
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            blockNumber() {
                this.axios.post('/api/callQualityInspection/block', {
                    id: this.id,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('阻断成功')
                        this.chatList = []
                        this.selectedId = ''
                        this.queryCall()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            }
        },
        mounted: function() {
            this.audio = document.getElementById("myAudio");
            this.queryState()
            this.queryCall()
            this.timer = setInterval(() => {
                this.queryCall()
                if(this.chatObj[this.selectedId]!=undefined&&this.selectedId!=''){
                    this.viewDel(this.selectedId, this.callee, this.duration, 2, this.callTime)
                }else{
                    this.chatList = []
                    this.selectedId = ''
                }
            }, 3000);
        },
        beforeDestroy() {
            clearInterval(this.timer);
        }
    }
</script>

<style scoped lang="less">
    .user-left{
        display: flex;
        max-width: 70%;
        margin-bottom: 20px;
        float: left;
        img{
            width: 32px;
            height: 32px;
        }
        div{
            padding: 8px 12px;
            background: rgba(179, 184, 193, 0.16);
            color: rgba(0, 0, 0, 1);
            font-size: 13px;
            border-radius: 4px;
            margin-left: 10px;
        }
    }
    .user-right{
        display: flex;
        max-width: 70%;
        margin-bottom: 20px;
        float: right;
        img{
            width: 32px;
            height: 32px;
        }
        div{
            padding: 8px 12px;
            background: rgba(179, 184, 193, 0.16);
            color: rgba(0, 0, 0, 1);
            font-size: 13px;
            border-radius: 4px;
            margin-right: 10px;
        }
    }
    .ant-switch-checked{
        background: rgba(246, 76, 79, 1);
    }
    .num-del{
        color:#1890FF;
        cursor: pointer;
    }
    .del-active{
        color: rgba(246, 76, 79, 1);
    }
</style>